import { ActionIcon, Tooltip, useMantineColorScheme } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { IconMoonStars, IconSun } from '@tabler/icons';
import { useContext } from 'react';
import { WindowContext } from '../../Service/Context/WindowContext';

const ThemeSettingsIcon = () => {
  const [colorScheme] = useLocalStorage({
    key: 'mantine-color-scheme',
    defaultValue: 'light',
    getInitialValueInEffect: true,
  });
  const { toggleColorScheme } = useMantineColorScheme();
  const { sm } = useContext(WindowContext)

  return (
    <div>
      <Tooltip label={colorScheme === 'dark' ? 'Hell' : 'Dunkel'} position="right" withArrow transition="slide-right">
        <ActionIcon
          sx={(theme) => ({
            color: colorScheme !== 'dark' ? (sm ? 'black' : theme.colors.blue[4]) : theme.colors.orange[1],
            backgroundColor: 'transparent',
            width: 40,
            height: 40,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          })}
        >
          {colorScheme === 'dark' && <IconSun size={24} onClick={() => toggleColorScheme('light')} />}
          {colorScheme !== 'dark' && <IconMoonStars size={24} onClick={() => toggleColorScheme('dark')} />}
        </ActionIcon>
      </Tooltip>
    </div>
  );
};

export default ThemeSettingsIcon;
